

// 获取TOKEN
export function getToken() {
  let data = JSON.parse(localStorage.getItem('datas'));
  let token = data && data.qrAuth.accessToken ? data.qrAuth.accessToken:"";
  return token;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js